export enum CHANNEL_TYPE {
  SITE = 'site',
}

export type TChannelType = CHANNEL_TYPE.SITE;
